export default __webpack_public_path__ + "static/media/dollar.acc5d160.svg";